import React from 'react';
import {Grid, TextField} from "@mui/material";
import * as Yup from 'yup';
import {useParams} from 'react-router-dom';
import useAuth from "../../../hooks/useAuth";
import GeneralEditor, {MODE_CREATE, MODE_EDIT} from "../../../components/CrudFrom/GeneralEditor";
import {executeMutationUtil, executeQueryUtil} from "../../../utils/gqlUtil";
import localStrings from "../../../localStrings";
import {useNavigate} from "react-router";
import {dashboardBaseRoute} from "../../../routes/dashboard";
import {not_found_path} from "../../../routes";
import {addDataChartImplementationToCache} from "../../../gql/chartImplementationGql";
import {
    addDataDashBoardToCache,
    createDashBoardMutation,
    getDashBoardQuery,
    updateDashBoardMutation
} from "../../../gql/dashBoardGql";

export const getDashBoard = async (userInDb, dashboardId,
                                   modeEdit, navigate) => {
    if (modeEdit == MODE_CREATE) {
        return null;
    }
    if (!modeEdit || modeEdit == MODE_EDIT) {
        var res =
            await executeQueryUtil(getDashBoardQuery(userInDb.id, dashboardId ));

        if (!res.data?.getDashBoard) {
            navigate('/' + not_found_path);
            return;
        }
        return res;
    }
    return null;
}

export const saveForm = async (item, values, modeEdit, navigate, userInDb, reloadCustomBoardList, setReloadCustomBoardList, setNavbarMobileReload) => {
    let data;
    if (!modeEdit || modeEdit == MODE_EDIT) {
        data = {
            ...item,
            ...values,
        };
        await executeMutationUtil(updateDashBoardMutation(userInDb.id, data));
        await setNavbarMobileReload();
        setReloadCustomBoardList(!reloadCustomBoardList);

    }

    else if (modeEdit == MODE_CREATE){
        data = {...values};
        const created = await executeMutationUtil(createDashBoardMutation(userInDb.id, data));
        await addDataDashBoardToCache(userInDb.id, [created.data?.addDashBoard]);
        await setNavbarMobileReload();
        if (navigate) {
            navigate("/" + dashboardBaseRoute + "/dashboards/detail/" + created.data?.addDashBoard?.id);
        }
        setReloadCustomBoardList(!reloadCustomBoardList)
    }


    return data;
}

const DashBoardCreateUpdateForm = ({className, modeEdit}) => {


    let {dashboardId} = useParams();

    const {
        userInDb,
        reloadCustomBoardList,
        setReloadCustomBoardList,
        setNavbarMobileReload,

    } = useAuth();
    const navigate = useNavigate();

    const buildFormValues = (item) => {
        return {
            initialValues: {
                name: item.name || '',

            },
            validationSchema: {
                name: Yup.string().max(255).required(localStrings.check.fieldRequired),
            }
        };
    }

    const getCardContentForm = ({
                                    errors,
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                    isSubmitting,
                                    setFieldValue,
                                    touched,
                                    values
                                }) => {
        return (
            <Grid
                container
                spacing={4}
            >

                {/*<p>{JSON.stringify(values)}</p>*/}
                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        fullWidth
                        helperText={touched.name && errors.name}
                        label={localStrings.name}
                        name="name"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        required
                        value={values.name}
                    />
                </Grid>


            </Grid>
        );
    }




    return (

        <>

            {userInDb &&
                <GeneralEditor getItemFunction={() =>
                    getDashBoard(userInDb, dashboardId, modeEdit, navigate)}
                               className={className}
                               buildFormValues={buildFormValues}
                               getCardContentForm={getCardContentForm}
                               saveForm={(item, values) =>
                                   saveForm(item, values, modeEdit, navigate, userInDb, reloadCustomBoardList, setReloadCustomBoardList, setNavbarMobileReload)}
                               applyButton={modeEdit == MODE_CREATE ? localStrings.create : localStrings.update}
                               resetFormProp={modeEdit == MODE_CREATE}
                               messageSuccess={modeEdit == MODE_CREATE ?
                                   localStrings.notif.dashboardCreated : localStrings.notif.dashboardUpdated}
                               titleForm={modeEdit == MODE_CREATE ? localStrings.createDashBoard : localStrings.updateDashBoard}
                               getPathToData={(result) => {
                                   return result.data.getDashBoard;
                               }}
                />
            }
        </>
    )
};

export default DashBoardCreateUpdateForm;
